/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* Auth0 Changes Start */
// const CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID || '{clientId}';
// const ISSUER = process.env.REACT_APP_OKTA_ISSUER||  'https://{yourOktaDomain}.com/oauth2/default';
// const DOMAIN = process.env.REACT_APP_AUTH_DOMAIN
// const OKTA_TESTING_DISABLEHTTPSCHECK = process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;
// const BASENAME = '/' || '';
// const dev = process.env.REACT_APP_DEV || false;
// const scopes = process.env.REACT_APP_API_SCOPE ? process.env.REACT_APP_API_SCOPE : ['openid','email','halo','offline_access']
// // BASENAME includes trailing slash
// const REDIRECT_URI = process.env.REACT_APP_OKTA_REDIRECT_URI
// export const config = {
//   oidc: {
//     clientId: CLIENT_ID,
//     issuer: ISSUER,
//     redirectUri: REDIRECT_URI,
//     scopes: ['openid','email','profile','offline_access'],
//     pkce: true,
//     disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
//   },
//   resourceServer: {
//     messagesUrl: 'http://localhost:8000/api/messages',
//   },
//   app: {
//     basename: BASENAME,
//   }
// };
// export function getConfig() {
//   // Configure the audience here. By default, it will take whatever is in the config
//   // (specified by the `audience` key) unless it's the default value of "YOUR_API_IDENTIFIER" (which
//   // is what you get sometimes by using the Auth0 sample download tool from the quickstart page, if you
//   // don't have an API).
//   // If this resolves to `null`, the API page changes to show some helpful info about what to do
//   // with the audience.
//   const audience = process.env.REACT_APP_AUDIENCE
    
//   return {
//     domain: ISSUER,
//     clientId: CLIENT_ID,
//     dev:dev,
//     ...(audience ? { audience } : null),
//   };
// }
/* Auth0 Changes End */

/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID || '{clientId}';
const ISSUER = process.env.REACT_APP_OKTA_ISSUER||  'https://{yourOktaDomain}.com/oauth2/default';
const OKTA_TESTING_DISABLEHTTPSCHECK = process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;
const BASENAME = '/' || '';
// BASENAME includes trailing slash
const REDIRECT_URI = process.env.REACT_APP_OKTA_REDIRECT_URI
export const config = {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid','email','halo','offline_access'],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  },
  resourceServer: {
    messagesUrl: 'http://localhost:8000/api/messages',
  },
  app: {
    basename: BASENAME,
  }
};